import { Helmet } from 'react-helmet-async'
import PropTypes from 'prop-types'

const BASE_URL = 'https://www.cpent.com'
const DEFAULT_KEYWORDS = 'cpent, cpentertainment, 씨피엔터테인먼트, CP Entertainment, 쿠팡엔터테인먼트, 씨피엔터, CPEnt, 쿠팡플레이, SNL 코리아, 직장인들, 엔터테인먼트, 아티스트 매니지먼트, 콘텐츠 제작, 신동엽, 이수지, 지예은, 김규원'

export default function SEO({ 
  title, 
  description, 
  path = '',
  image = '/images/home-bg.png',
  keywords = DEFAULT_KEYWORDS,
  type = 'website',
  jsonLd = null
}) {
  const fullTitle = title 
    ? `${title} | CP Entertainment - 씨피엔터테인먼트` 
    : 'CP Entertainment - 씨피엔터테인먼트'
  
  const fullUrl = `${BASE_URL}${path}`
  const fullImageUrl = image.startsWith('http') ? image : `${BASE_URL}${image}`

  // 기본 BreadcrumbList 구조화 데이터
  const breadcrumbJsonLd = {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    "itemListElement": [
      {
        "@type": "ListItem",
        "position": 1,
        "name": "홈",
        "item": BASE_URL
      },
      ...(title ? [{
        "@type": "ListItem",
        "position": 2,
        "name": title,
        "item": fullUrl
      }] : [])
    ]
  }

  return (
    <Helmet>
      {/* Basic Meta Tags */}
      <title>{fullTitle}</title>
      <meta name="description" content={description} />
      <meta name="keywords" content={keywords} />
      <link rel="canonical" href={fullUrl} />

      {/* Open Graph Meta Tags */}
      <meta property="og:type" content={type} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={fullUrl} />
      <meta property="og:image" content={fullImageUrl} />
      <meta property="og:image:width" content="1200" />
      <meta property="og:image:height" content="630" />
      <meta property="og:image:alt" content={title ? `${title} - CP Entertainment` : 'CP Entertainment 씨피엔터테인먼트'} />
      <meta property="og:site_name" content="CP Entertainment - 씨피엔터테인먼트" />
      <meta property="og:locale" content="ko_KR" />

      {/* Twitter Card Meta Tags */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={fullImageUrl} />
      <meta name="twitter:image:alt" content={title ? `${title} - CP Entertainment` : 'CP Entertainment 씨피엔터테인먼트'} />

      {/* Breadcrumb JSON-LD */}
      {title && (
        <script type="application/ld+json">
          {JSON.stringify(breadcrumbJsonLd)}
        </script>
      )}

      {/* Custom JSON-LD */}
      {jsonLd && (
        <script type="application/ld+json">
          {JSON.stringify(jsonLd)}
        </script>
      )}
    </Helmet>
  )
}

SEO.propTypes = {
  title: PropTypes.string,
  description: PropTypes.string.isRequired,
  path: PropTypes.string,
  image: PropTypes.string,
  keywords: PropTypes.string,
  type: PropTypes.string,
  jsonLd: PropTypes.object
}
